/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-bitwise */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootState';
import { AllDefects, TubeConfiguration } from '../../VesselInformation/utils/tubeChartTypes';
import { Polygon } from '../../VesselInformation/components/TubeChart/Diagram/gridClass';
import { TubeDetailPoly, TubePolyType } from '../types';
import TubeChartLayout from './tubeChartLayout';
import { CombineReportEnum, PDFReportEnum, ReportPart1 } from '../helper';
import { NavigationArrow } from '../../../utils/Constant';
import EastCompass from '../../../assets/compass/East.svg';
import WestCompass from '../../../assets/compass/West.svg';
import NorthCompass from '../../../assets/compass/North.svg';
import SouthCompass from '../../../assets/compass/South.svg';
import NECompass from '../../../assets/compass/NE.svg';
import NWCompass from '../../../assets/compass/NW.svg';
import SECompass from '../../../assets/compass/SE.svg';
import SWCompass from '../../../assets/compass/SW.svg';

function TubeBundleLayoutSection() {
  const { reportPdfResponse3, tableContent } = useSelector((state:RootState) => state.reportPdfSliceReducer);

  const tubesPoly:TubePolyType[] = useMemo(
    () => reportPdfResponse3?.Tube_Bundle_Layout?.map((tubeDetails) => {
      let allDefects:AllDefects[] = [];
      const temp:TubeDetailPoly[] = tubeDetails?.map((details) => {
        const chartDetails:TubeConfiguration = {
          CircleInfos: details?.CircleInfos,
          IsOte: details?.IsOte,
          TubeSize: details?.TubeSize,
          NumOfRows: details?.NumOfRows,
          RowLength: details?.RowLength,
          Panel: details?.Panel,
          Group: details?.Group,
          Layout: details?.Layout,
          IsTestEndChanges: details.OriginalTestEnd,
          ChartId: details.ChartId,
          VesselId: details.VesselId,
          VesselTop: details.VesselTop,
          Offset: details.Offset,
          OriginalTestEnd: details.OriginalTestEnd,
          RemovedConfig: details.RemovedConfig,
        };
        const poly = new Polygon(chartDetails);
        poly.displayDefects(details?.Defects);
        allDefects = [...allDefects, ...poly.allDefects];

        return {
          poly,
          details,
        };
      });

      const uniqueDefectsMap = new Map<string, AllDefects>();

      allDefects.forEach((defect) => {
        uniqueDefectsMap.set(defect.color, defect);
      });

      const uniqueDefectsArray = Array.from(uniqueDefectsMap.values());

      return {
        tubePolyList: temp,
        allDefects: uniqueDefectsArray,
      };
    }),
    [reportPdfResponse3?.Tube_Bundle_Layout],
  );

  function getTextColor(backgroundColor: string) {
    // Convert HEX to RGB
    const rgb = parseInt(backgroundColor.slice(1), 16);
    const r = (rgb >> 16) & 0xff;
    const g = (rgb >> 8) & 0xff;
    const b = (rgb >> 0) & 0xff; // Calculate brightness
    const brightness = (0.299 * r + 0.587 * g + 0.114 * b); // Return light or dark text based on brightness
    return (brightness < 128) ? '#FFFFFF' : '#000000'; // White for dark, black for light
  }

  function customLabelList(tubeDataDefectList: AllDefects[]) {
    if (!tubeDataDefectList || !Array.isArray(tubeDataDefectList)) {
      return null;
    }

    if (tubeDataDefectList.length === 0) {
      return 'No Significant defects were found';
    }

    // Helper function to chunk the array into smaller arrays of size 10
    const chunkArray = (array: AllDefects[], chunkSize: number) => {
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    };

    const chunks = chunkArray(tubeDataDefectList, 5);
    const rows = [];
    for (let i = 0; i < chunks.length; i += 2) {
      rows.push(chunks.slice(i, i + 2));
    }

    return (

      <div style={{ marginBottom: '10px' }}>
        {rows.map((row) => (
          <div style={{
            display: 'flex',
            gap: '40px',
            width: '100%',
          }}
          >
            {row.map((chunk) => (
              <div style={{
                width: '360px',
              }}
              >
                {chunk.map((data: AllDefects) => (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '10px',
                    }}
                  >
                    <div style={{
                      display: 'flex',
                    }}
                    >
                      <div
                        className="tubeChartLegend"
                        style={{
                          backgroundColor: data.color !== '' ? data.color : 'transparent',
                          fontSize: '10px',
                          color: getTextColor(data.color !== '' ? data.color : 'transparent'),
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          borderRadius: '50%',
                          width: '20px',
                          minWidth: '20px',
                          height: '20px',
                          marginRight: '3px',
                        }}
                      >
                        {data.tag}
                      </div>
                      <div style={{ fontSize: '17px', fontWeight: 500, color: data.actionRequired ? 'red' : 'inherit' }}>{` = ${data.description}`}</div>
                    </div>
                    {data.actionRequired && <div style={{ marginLeft: '40px', fontSize: '17px', fontWeight: 500 }}>REQUIRES ACTION</div>}
                  </div>
                ))}
              </div>
            ))}
          </div>
        ))}
      </div>
    );
  }

  const groupArrays = (arr: TubeDetailPoly[]) => {
    const ar = Object.values(
      arr.reduce((acc, item) => {
        const key = item?.details?.JobOrder ?? 'unknown';
        (acc[key] = acc[key] || []).push(item);
        return acc;
      }, {} as Record<string, TubeDetailPoly[]>),
    );
    return ar;
  };

  const getTitle = (panel: string, offset: string, layout: string) => {
    let title = '';
    if (panel === '1') {
      title += `${layout === '2' ? 'LEFT' : 'TOP'} SECTION - `;
    } else if (panel === '2') {
      title += 'MIDDLE SECTION - ';
    } else if (panel === '3') {
      title += `${layout === '2' ? 'RIGHT' : 'BOTTOM'} SECTION - `;
    }

    if (offset === '1') {
      title += 'Rows Numbered (🠆), Tubes Numbered (🠇)';
    } else {
      title += 'Rows Numbered (🠇), Tubes Numbered (🠆)';
    }
    return title;
  };
  const getTwoOffsetTitle = (panel: string, offset: string, layout: string) => {
    let title = '';
    if (panel === '1') {
      title += `${layout === '2' ? 'LEFT' : 'TOP'} SECTION - `;
    } else if (panel === '2') {
      title += `${layout === '2' ? 'RIGHT' : 'BOTTOM'} SECTION - `;
    }

    if (offset === '1') {
      title += 'Rows Numbered (🠆), Tubes Numbered (🠇)';
    } else {
      title += 'Rows Numbered (🠇), Tubes Numbered (🠆)';
    }
    return title;
  };

  const getDirection = (dir: string) => {
    const getArrow = (clas: string) => <div className={clas}>Top of Vessel</div>;
    const getCompass = (compass: string) => (
      <div className="compassDiv">
        <img src={compass} alt="" className="compass" />
        <p>Top of Vessel</p>
      </div>
    );
    switch (dir) {
      case NavigationArrow.UP: return getArrow('topVesselArrow');
      case NavigationArrow.DOWN: return getArrow('downVesselArrow');
      case NavigationArrow.LEFT: return getArrow('leftVesselArrow');
      case NavigationArrow.RIGHT: return getArrow('rightVesselArrow');
      case NavigationArrow.EAST: return getCompass(EastCompass);
      case NavigationArrow.WEST: return getCompass(WestCompass);
      case NavigationArrow.NORTH: return getCompass(NorthCompass);
      case NavigationArrow.SOUTH: return getCompass(SouthCompass);
      case NavigationArrow.NORTH_EAST: return getCompass(NECompass);
      case NavigationArrow.NORTH_WEST: return getCompass(NWCompass);
      case NavigationArrow.SOUTH_EAST: return getCompass(SECompass);
      case NavigationArrow.SOUTH_WEST: return getCompass(SWCompass);
      default: return <div className="">Top of Vessel</div>;
    }
  };

  const panelSort = (panelData: TubeDetailPoly[]) => panelData?.sort((x, y) => Number(x.details.Panel) - Number(y.details.Panel));

  const hasRemovedOffset = (panelData: TubeDetailPoly[]) => panelData?.some((item) => {
    const arr1Length = item?.details?.CircleInfos?.length ?? 0;
    const arr2Length = Object.values(item?.details?.RemovedConfig)?.reduce(
      (sum, arr) => sum + arr.length,
      0,
    );

    return (arr1Length === arr2Length);
  });
  const panelSortAndFilter = (panelData: TubeDetailPoly[]) => {
    const isRemovedData = panelData?.map((item) => {
      const arr1Length = item?.details?.CircleInfos?.length ?? 0;
      const arr2Length = Object.values(item?.details?.RemovedConfig)?.reduce(
        (sum, arr) => sum + arr.length,
        0,
      );
      if ((arr1Length === arr2Length)) {
        return { ...item, isRemoved: true };
      }
      return { ...item, isRemoved: false };
    });
    const sortedData = isRemovedData?.sort((x, y) => Number(x.details.Panel) - Number(y.details.Panel));
    const filteredData = sortedData?.filter((item) => !item?.isRemoved);
    const orderedPanelData = filteredData?.map((item, index) => ({
      ...item,
      details: {
        ...item.details,
        Panel: String(index + 1),
      },
    }));

    return orderedPanelData;
  };

  return (
    <div className="largePage">
      {tubesPoly?.map((tubeDetails, index) => {
        const hasVisiblePoly = tubeDetails?.tubePolyList?.some(
          (details) => details?.poly?.totalVisible > 0,
        );

        if (!hasVisiblePoly) {
          return null;
        }

        return (
          <>
            {tubeDetails?.tubePolyList?.length === 1 && (
            <div className="pl30 pr30 pageHeader">
              <div className="topHeader">
                <div className="mt10">
                  {ReportPart1(tableContent, CombineReportEnum.COMBINE_TUBE_CHARTS, PDFReportEnum.PDF_TUBE_CHARTS, 'Tube Bundle Layout')}

                  {/* {`Part ${toRoman(index + 1)} - Tube Bundle Layout`} */}
                </div>
                <div>{`S/N ${reportPdfResponse3?.JobOrderData?.SerialNumber}`}</div>
              </div>
              <div className="bigHeadingText textCenter mt10">
                {tubeDetails?.tubePolyList?.[0]?.details?.VesselName}
                {' '}
                Section
              </div>
            </div>
            )}
            {tubeDetails?.tubePolyList?.length === 1 && (
              <div className="pl30 pr30 tubeBundleHeader">
                <div className="tubesNumberedArrow">
                  <div>
                    {tubeDetails?.tubePolyList?.[0]?.details?.Offset === '1' ? 'Rows Numbered' : 'Tubes Numbered'}
                    <br />
                    {' '}
                    Left to Right
                  </div>
                  <div className="mt20">
                    {tubeDetails?.tubePolyList?.[0]?.details?.Offset === '1' ? 'Tubes Numbered' : 'Rows Numbered'}
                    <br />
                    {' '}
                    Top to Bottom
                  </div>
                </div>
                {getDirection(tubeDetails?.tubePolyList?.[0]?.details?.VesselTop?.toLowerCase())}
                {/* <div className="topVesselArrow">Top of Vessel</div> */}
                <div className="tubeBundleRight">
                  {tubeDetails?.tubePolyList?.[0]?.details?.TestEnd}
                </div>
              </div>
            )}
            {tubeDetails?.tubePolyList?.length > 1 && (
              groupArrays(tubeDetails?.tubePolyList)?.map((details, groupIndex) => (
                // eslint-disable-next-line react/no-array-index-key
                <React.Fragment key={groupIndex}>
                  {details.length > 1 && !(hasRemovedOffset(details))
                    && panelSort(details)?.map((detail) => (
                      <>
                        {detail?.details?.Panel === '1' && (
                        <div className="pl30 pr30 pageHeader">
                          <div className="topHeader">
                            <div className="mt10">
                              {ReportPart1(tableContent, CombineReportEnum.COMBINE_TUBE_CHARTS, PDFReportEnum.PDF_TUBE_CHARTS, 'Tube Bundle Layout')}

                              {/* {`Part ${toRoman(index + 1)} - Tube Bundle Layout`} */}
                            </div>
                            <div>{`S/N ${reportPdfResponse3?.JobOrderData?.SerialNumber}`}</div>
                          </div>
                          <div className="bigHeadingText textCenter mt10">
                            {detail?.details?.VesselName}
                            {' '}
                            Section
                          </div>
                        </div>
                        )}
                        {detail?.details?.Panel === '1' && (
                        <div className="pl30 pr30 tubeBundleHeader">
                          <div className="tubeBundleRight" />
                          {getDirection(detail?.details?.VesselTop?.toLowerCase())}
                          {/* <div className="topVesselArrow">Top of Vessel</div> */}
                          <div className="tubeBundleRight">{detail?.details?.TestEnd}</div>
                        </div>
                        )}
                        <TubeChartLayout
                          key={`${detail?.details?.ChartId}_${detail?.details?.JobOrder}`}
                          poly={detail?.poly}
                          head={getTitle(detail?.details?.Panel, detail?.details?.Offset, detail?.details?.Layout)}
                          // head={`Left section (Rows LtR, Tubes TtB)`}
                        />
                        {detail?.details?.Panel === '3' && (
                        <div style={{
                          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto',
                        }}
                        >
                          {customLabelList(details?.map((d) => d?.poly?.allDefects).flat())}
                        </div>
                        )}
                        {(index !== tubesPoly.length - 1 && detail?.details?.Panel === '3') && <div className="page-break" />}
                      </>
                    ))}
                  {details.length > 1 && hasRemovedOffset(details)
                    && panelSortAndFilter(details)?.map((detail) => (
                      <>
                        {detail?.details?.Panel === '1' && (
                        <div className="pl30 pr30 pageHeader">
                          <div className="topHeader">
                            <div className="mt10">
                              {ReportPart1(tableContent, CombineReportEnum.COMBINE_TUBE_CHARTS, PDFReportEnum.PDF_TUBE_CHARTS, 'Tube Bundle Layout')}

                              {/* {`Part ${toRoman(index + 1)} - Tube Bundle Layout`} */}
                            </div>
                            <div>{`S/N ${reportPdfResponse3?.JobOrderData?.SerialNumber}`}</div>
                          </div>
                          <div className="bigHeadingText textCenter mt10">
                            {detail?.details?.VesselName}
                            {' '}
                            Section
                          </div>
                        </div>
                        )}
                        {detail?.details?.Panel === '1' && (
                        <div className="pl30 pr30 tubeBundleHeader">
                          <div className="tubeBundleRight" />
                          {getDirection(detail?.details?.VesselTop?.toLowerCase())}
                          {/* <div className="topVesselArrow">Top of Vessel</div> */}
                          <div className="tubeBundleRight">{detail?.details?.TestEnd}</div>
                        </div>
                        )}
                        <TubeChartLayout
                          key={`${detail?.details?.ChartId}_${detail?.details?.JobOrder}`}
                          poly={detail?.poly}
                          head={getTwoOffsetTitle(detail?.details?.Panel, detail?.details?.Offset, detail?.details?.Layout)}
                          // head={`Left section (Rows LtR, Tubes TtB)`}
                        />
                        {detail?.details?.Panel === '2' && (
                        <div style={{
                          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto',
                        }}
                        >
                          {customLabelList(details?.map((d) => d?.poly?.allDefects).flat())}
                        </div>
                        )}
                        {(index !== tubesPoly.length - 1 && detail?.details?.Panel === '2') && <div className="page-break" />}
                      </>
                    ))}
                  {details.length === 1
                    && (
                      <>
                        <div className="pl30 pr30 pageHeader">
                          <div className="topHeader">
                            <div className="mt10">
                              {ReportPart1(tableContent, CombineReportEnum.COMBINE_TUBE_CHARTS, PDFReportEnum.PDF_TUBE_CHARTS, 'Tube Bundle Layout')}

                              {/* {`Part ${toRoman(index + 1)} - Tube Bundle Layout`} */}
                            </div>
                            <div>{`S/N ${reportPdfResponse3?.JobOrderData?.SerialNumber}`}</div>
                          </div>
                          <div className="bigHeadingText textCenter mt10">
                            {details?.[0]?.details?.VesselName}
                            {' '}
                            Section
                          </div>
                        </div>
                        <div className="pl30 pr30 tubeBundleHeader">
                          <div className="tubesNumberedArrow">
                            <div>
                              {details?.[0]?.details?.Offset === '1' ? 'Rows Numbered' : 'Tubes Numbered'}
                              <br />
                              {' '}
                              Left to Right
                            </div>
                            <div className="mt20">
                              {details?.[0]?.details?.Offset === '1' ? 'Tubes Numbered' : 'Rows Numbered'}
                              <br />
                              {' '}
                              Top to Bottom
                            </div>
                          </div>
                          {getDirection(details[0]?.details?.VesselTop?.toLowerCase())}
                          {/* <div className="topVesselArrow">Top of Vessel</div> */}
                          <div className="tubeBundleRight">{details?.[0]?.details?.TestEnd}</div>
                        </div>
                        <TubeChartLayout
                          key={details[0]?.details?.ChartId}
                          poly={details[0]?.poly}
                        />
                        <div style={{
                          width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto',
                        }}
                        >
                          {customLabelList(details?.[0]?.poly?.allDefects)}
                        </div>
                        {index !== tubesPoly.length - 1 && <div className="page-break" />}
                      </>
                    )}
                </React.Fragment>
              ))
            )}
            {tubeDetails?.tubePolyList?.length === 1 && (tubeDetails?.tubePolyList?.map((details) => (
              <>
                <TubeChartLayout key={details?.details?.ChartId} poly={details?.poly} />
                <div style={{
                  width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto',
                }}
                >
                  {customLabelList(tubeDetails.allDefects)}
                </div>
                {index !== tubesPoly.length - 1 && <div className="page-break" />}
              </>
            )))}

            {/* <div style={{
              width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto',
            }}
            >
              {customLabelList(tubeDetails.allDefects)}
            </div> */}

            {/* {index !== tubesPoly.length - 1 && <div className="page-break" />} */}
          </>
        );
      })}
    </div>
  );
}

export default TubeBundleLayoutSection;
